import React, { useState, useEffect } from 'react'
import styled from 'styled-components';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { COLOR_BLUE, COLOR_GREEN, COLOR_GREEN_BUTTON, COLOR_WHITE } from '../constants/colors';
import { IFilterArray } from '../routes/annonces/AnnoncesList'

const Wrapper = styled.div`
  z-index: 1;
  position: relative;
  margin-left: 55px;

  .icon {
    font-size: big;
    margin-left: 18px;
  }

  .main-btn {
    width: 230px;
    height: 49px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    border-radius: 10px;
    background-color: ${COLOR_GREEN_BUTTON};
    color: ${COLOR_GREEN};
  } 

  button {
    border: none;
    font-size: 18px;
    font-weight: bold;
    margin-top: 0;
    padding: 10px;
    border: none;
    color: ${COLOR_BLUE};
    background-color: ${COLOR_WHITE};
    white-space: nowrap;

    i {
      font-size: 14px;
    }
  }

  button:hover {
    cursor: pointer;
    background-color: ${COLOR_GREEN_BUTTON};
    color: ${COLOR_GREEN};
  }

  @media screen and (max-width: 1500px ) {
    margin: 5px auto;
  }
`

const FilterValues = styled.div`
  @media screen and (min-width: 1200px ) {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
  }
  border-radius: 13px;

  display: flex;
  flex-direction: column;
  margin-top: 8px;
  border-box: box-sizing;
  padding: 0;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.06);

  button:first-child {
    border-radius: 13px 13px 0 0;
  }

  button:last-child {
    border-radius: 0 0 13px 13px;
  }
  .selected {
    background-color: ${COLOR_GREEN_BUTTON};
    color: ${COLOR_GREEN};
  }
`

const InputValues = styled.div`
  @media screen and (min-width: 1200px ) {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
  }
  display: flex;
  position: relative;
  margin-top: 12px;
  border-radius: 13px;
  width: 100%;
  color : ${COLOR_GREEN};
  text-align: center;
  justify-content: center;
  background: ${COLOR_WHITE};

  input {
    width: 60px;
    margin-right: 7px;
    border: 2px solid ${COLOR_GREEN_BUTTON};
  }

  @media screen and (min-width: 1450px ) {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
  }

`

const useDebounce = (value: number, delay: number) => {
  const [debounceValue, _setDebounceValue] = useState<number>(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      _setDebounceValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debounceValue;
}
  


const Filters : React.FC<IFilterArray> =  ({name, values, selectedValues, data, handleChange, handleInput} : IFilterArray) => {

    const [ buttonState, _setButtonState ] = useState<boolean>(false)
    const [ valueInput, _setvalueInput ] = useState<number>(0)
    const debounce : number = useDebounce(valueInput, 1000);
  

    useEffect(() => {
      if (debounce) {
        handleInput && handleInput(valueInput, name)
        _setButtonState(false)
      }
    }, [debounce, handleInput, name, valueInput])
  
    const onChangeInput = (e : React.ChangeEvent<HTMLInputElement>) => {
      _setvalueInput(Number(e.target.value))
    }

    return (
      <Wrapper>
        <button 
          onClick={() => _setButtonState(!buttonState)}
          className='main-btn'
        >
          {name}
          {data && valueInput !== 0 && (<i>&nbsp;({valueInput} {data.shortLabel})</i>)}
          {
            (
              !buttonState
              && <ExpandMoreIcon className='icon'/>
            )
            || <ExpandLessIcon className='icon'/>
          }
        </button>
        {
          buttonState && values && 
           <FilterValues>
            {
              values?.map(value => 
                <button
                  onClick={() => { handleChange && handleChange(name, value); _setButtonState(false) }}
                  key={values.indexOf(value)}
                  className={selectedValues?.includes(value) ? "selected" : ""}
                >
                  {value}
                </button>
              )
            }
           </FilterValues>
        }
        {
          buttonState && data &&
          <InputValues>
            <input 
              type='number'
              step={data.step.toString()}
              min={data.min.toString()}
              value={valueInput}
              onChange={(value) => {onChangeInput(value)}}
            >
            </input>
            {data.label}
          </InputValues>
        }
      </Wrapper>
    );
}

export default Filters;